import { createClient } from '@sanity/client'

const projectId = 'tav2vlxd'
const dataset = 'werzalit'
const useCdn = true
const apiVersion = '2021-08-31'


export const client = createClient({
  projectId,
  dataset,
  useCdn,
  apiVersion
})


export const fetchSettings = async () => {
  const query = `*[_type == "settings"][0]{
        logo {
          asset-> {
            url
          }
        },
        mainColor,
        footer
      }`;
  const settings = await client.fetch(query);
  return settings;
};


export const fetchMenu = async () => {
  const query = `*[_type == "menu"]{ 
      linkType, 
      title, 
      type, 
      category -> {title},
      page -> {slug},
      section -> {title},
      externalUrl,
      order
    }`; // Adjust the query as necessary
  const menu = await client.fetch(query);
  return menu;
};



export const fetchPage = async (slug) => {
  console.log(
    slug
  )
  const query = `*[_type == "pages" && slug.current == "${slug}"][0]{
    name,
    slug,
    sections[]->{
      name,
      type,
      sectionOne {
        heading,
        text,
        introText,
        files[]->{title,file{asset->{url}}},
        icons[]->{title,description,iconImage{asset->{url}}},
        images[]->{title,description,image{asset-> {url}}}
      },
      sectionImages {
        heading,
        text,
        images[]->{title,description,image{asset-> {url}}}
      },
      sectionMultiple {
        heading,
        text,
        contentArray[]{
          heading,
          text,
          link->{slug},
          image->{title,description,image{asset-> {url}}},
          icon->{title,description,iconImage{asset->{url}}},
          files[]->{...},
        },
      },
      sectionSlider {
        autorun,
        fullBG,
        slideArray[]{
          heading,
          text,
          image->{title,description,image{asset-> {url}}},
          slideAction,
        }
      }
    }
  }`;
  const page = await client.fetch(query);
  console.log(page)
  return page;
};





export const urlForImage = (source) => {
  // Ensure that source image contains a valid reference
  if (!source?.asset?._ref) {
    return undefined;
  }

 // return imageBuilder?.image(source).auto("format").fit("max");
};

export function resolveOpenGraphImage(image, width = 1200, height = 627) {
  if (!image) return;
  const url = urlForImage(image)?.width(1200).height(627).fit("crop").url();
  if (!url) return;
  return { url, alt: image?.alt, width, height };
}






export const urlFor = (source) => {
 return ""
  // return builder.image(source);
};
